define('model/workflow.form.data.model',['require','exports','module','underscore','backbone','./base.workflow.model','datakit/datakit'],function(require, exports, module) {
  //prettier-ignore
  var _                 = require('underscore'),
      Backbone          = require('backbone'),
      BaseWorkflowModel = require('./base.workflow.model'),
      DataKit           = require('datakit/datakit');

  var WorkflowFormProperty = BaseWorkflowModel.extend({
    childModels: {
      enumValues: Backbone.Model,
    },
  });

  var WorkflowFormDataModel = BaseWorkflowModel.extend({
    radioRequests: {
      'models WorkflowFormDataModel': '@constructor',
    },

    relationshipTypes: {
      hasOne: DataKit.AbstractHasOneRelationshipType.extend({
        supportedForeignKey: 'taskId',
        configureResource: function() {
          this.resource.set(this.foreignKey, this.foreignModel.id);
        },
      }),
    },

    defaults: function() {
      return {
        formProperties: [],
      };
    },

    childModels: {
      formProperties: WorkflowFormProperty,
    },

    url: function() {
      return DataKit.url.template('/api/v1/coi-workflow/form/form-data?taskId=:taskId', this, this._urlParams);
    },

    relationships: {
      routingActionCollection: {
        type: 'extracted',
        extract: function(model) {
          var choiceFormProperty, formProperties, taskDefinitionKey, enumValues;
          var taskModel = _.result(model.parentRelationship, 'foreignModel');

          if (taskModel) {
            formProperties = model.get('formProperties');
          }
          if (formProperties && taskModel) {
            choiceFormProperty = formProperties.get(taskModel.get('taskDefinitionKey'));
          }
          if (choiceFormProperty) {
            enumValues = choiceFormProperty.get('enumValues').map(function(enumValue) {
              var enumValueName = JSON.parse(enumValue.get('name'));
              return {
                displayName: enumValueName.displayName,
                actionDirection: enumValueName.actionDirection,
                routingId: enumValue.id,
              };
            });
          }
          return enumValues ? enumValues : [];
        },
        resourceClass: Backbone.Collection.extend({ comparator: 'actionDirection' }),
      },
    },
  });

  module.exports = WorkflowFormDataModel;
});

